/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16qs1aef%7Bbox-shadow%3A0%208px%209pt%20rgba(9%2C30%2C66%2C0)%2C0%200%201px%20rgba(9%2C30%2C66%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._v5649spz%7Btransition%3Abox-shadow%20.5s%20ease%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16qs130s%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1bhr%7Bbackground-color%3Avar(--ds-surface-overlay%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko12b0%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko1mok%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._tzy4idpf%7Bopacity%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._tzy4kb7n%7Bopacity%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._v564fs5d%7Btransition%3Aopacity%20.5s%20ease%7D");
import { fg } from '@atlaskit/platform-feature-flags';
import { useThemeObserver } from '@atlaskit/tokens';
import AIGlowingBorder from './ai-glowing-border';
import { AI_BORDER_PALETTE } from './constants';
import type { AIPrismProps } from './types';
const contentStyles = null;
const contentStylesPrismVisible = null;
const animatedSvgContainerStyles = {
  true: "_v564fs5d _tzy4kb7n",
  false: "_v564fs5d _tzy4idpf"
};
const borderRadiusStyles = {
  large: "_2rko1mok",
  small: "_2rko12b0"
};
const popupContainerStyles = null;
const AIPrism = ({
  borderRadius = 'large',
  children,
  isGlowing = true,
  isMoving = true,
  isVisible,
  testId
}: AIPrismProps): JSX.Element => {
  const {
    colorMode = 'light'
  } = useThemeObserver();
  return <AIGlowingBorder palette={AI_BORDER_PALETTE[colorMode] ?? AI_BORDER_PALETTE.light} isGlowing={isGlowing} isMoving={isMoving} testId={testId} className={ax([animatedSvgContainerStyles[isVisible ? 'true' : 'false'], fg('platform_sl_connect_account_flag') && borderRadiusStyles[borderRadius]])}>
			<div className={ax(["_2rko1mok _bfhk1bhr _16qs130s", "_v5649spz", isVisible && "_16qs1aef"])}>
				{children}
			</div>
		</AIGlowingBorder>;
};
export default AIPrism;